export default "__VITE_ASSET__DGTaOMPq__"